import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';

const EliminarCuentaModal = ({ show, onHide, onConfirm, accounts, isDeleting }) => {
  const [confirmWord, setConfirmWord] = useState('');

  // Reset the input when the modal is opened
  useEffect(() => {
    if (show) {
      setConfirmWord('');
    }
  }, [show]);

  if (!accounts || accounts.length === 0) return null;

  const isMultiple = accounts.length > 1;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-danger fs-5">Confirmar Eliminación</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-2">
        <p className="text-secondary mb-2">
          {isMultiple
            ? `¿Estás seguro de que deseas eliminar las siguientes ${accounts.length} cuentas?`
            : <>¿Estás seguro de que deseas eliminar la cuenta <strong>{accounts[0].vCodigoCuenta} - {accounts[0].vNombreCuenta}</strong>?</>}
        </p>

        {isMultiple && (
          <div className="bg-white border rounded p-2 mb-3" style={{ maxHeight: '150px', overflowY: 'auto' }}>
            <ul className="mb-0 text-muted small ps-3">
              {accounts.map(acc => (
                <li key={acc.idCuentaContable}>{acc.vCodigoCuenta} - {acc.vNombreCuenta}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="bg-light p-3 rounded mb-3 text-muted" style={{ fontSize: '0.9rem', borderLeft: '4px solid #dc3545' }}>
          <strong>Aviso:</strong> {isMultiple ? 'Al eliminar estas cuentas, cualquier elemento clasificado en ellas quedará sin clasificación.' : 'Al eliminar esta cuenta, cualquier elemento clasificado en ella quedará sin clasificación.'} Se realizará un borrado lógico para mantener la integridad de los datos.
        </div>
        <Form.Group>
          <Form.Label className="text-secondary small">Para confirmar, escribe la palabra <strong>ELIMINAR</strong>:</Form.Label>
          <Form.Control
            type="text"
            value={confirmWord}
            onChange={(e) => setConfirmWord(e.target.value)}
            placeholder="ELIMINAR"
            autoComplete="off"
            className="text-center"
            disabled={isDeleting}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="light" className="text-muted" onClick={onHide} disabled={isDeleting}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={() => onConfirm(accounts)}
          disabled={confirmWord !== 'ELIMINAR' || isDeleting}
          className="px-4"
        >
          {isDeleting ? 'Eliminando...' : (isMultiple ? 'Eliminar Cuentas' : 'Eliminar Cuenta')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EliminarCuentaModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      vCodigoCuenta: PropTypes.string,
      vNombreCuenta: PropTypes.string
    })
  ),
  isDeleting: PropTypes.bool
};

export default EliminarCuentaModal;
